var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnFiber1G(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1180_4682)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 0C1.34315 0 0 1.34315 0 3V27C0 28.6569 1.34315 30 3 30H9V25H21V30H27C28.6569 30 30 28.6569 30 27V3C30 1.34315 28.6569 0 27 0H3Z",
    fill: "#89B980"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1180_4682"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 3C0 1.34315 1.34315 0 3 0H27C28.6569 0 30 1.34315 30 3V27C30 28.6569 28.6569 30 27 30H3C1.34315 30 0 28.6569 0 27V3Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnFiber1G);
export default __webpack_public_path__ + "static/media/icn_fiber_1g.b93f1e9bfa3358450158c9698ddb4b30.svg";
export { ForwardRef as ReactComponent };